import { useIssue474AbTestStore } from '@/store/ab_test_issue_474'
import { ISSUE_474_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import useABTestV2 from '@/utils/abtest/useABTestV2'

export function useIssue474AbTest() {
  const store = useIssue474AbTestStore()

  const initialize = () => {
    store.abTestResult = useABTestV2(ISSUE_474_AB_TEST_CONFIG)
  }

  const pattern = computed<'a' | 'b' | null>(() => {
    const result = store.abTestResult
    if (!result) return null
    if (result.isAPattern) return 'a'
    if (result.isBPattern) return 'b'
    return null
  })

  return {
    initialize,
    pattern
  }
}
